// extracted by mini-css-extract-plugin
module.exports = {"container":"EcommerceProductList_container__IOqgx","item":"EcommerceProductList_item__hAvuS","title":"EcommerceProductList_title__UsApj","list":"EcommerceProductList_list__b5Q3D"};